/* unplugin-vue-components disabled */import { render } from "./item-vocabulary-mcq.vue?vue&type=template&id=0587bbbb"
import script from "./item-vocabulary-mcq.vue?vue&type=script&lang=js"
export * from "./item-vocabulary-mcq.vue?vue&type=script&lang=js"

import "./item-vocabulary-mcq.vue?vue&type=style&index=0&id=0587bbbb&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__